export default __webpack_public_path__ + "static/media/gallery_01.3ff80e40.jpg";